import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://8056962443a9b2d780d6d72e66a70eb9@o4507544538447872.ingest.us.sentry.io/4508066014429184',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ["mingle-activation"],
      behaviour: "drop-error-if-contains-third-party-frames",
    }),
  ],
  tracesSampleRate: 1.0,
});
